import { SerializedChoice } from '@xlearn/common'

export function customInstruction(content: SerializedChoice) {
  const hasMoreCorrectAnswers = content.answers.filter(x => x.score > 0).length > 1
  if (hasMoreCorrectAnswers) {
    return 'choices' // language key with 'instruction_labels.' prefix
  }

  return ''
}
